import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SubscriptionPlan } from '@vi-iot/client';
import { CommercialBookingPlansSpecification } from './commercial-booking-plans-specification';

@Component({
  selector: 'app-commercial-booking-plans-spec',
  templateUrl: './commercial-booking-plans-spec.component.html',
  styleUrls: ['./commercial-booking-plans-spec.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommercialBookingPlansSpecComponent {
  readonly subscriptionsPlanType = SubscriptionPlan;
  readonly commercialBookingPlansSpecification = CommercialBookingPlansSpecification;
}
